import { SensorsSdk ,StatisticEventType} from '@master/master-sensors';
import { setting_obj } from '~/settings/setting';
// console.log('SensorsSdk', SensorsSdk.getDeviceId());
const sensors = new SensorsSdk({
  url: `${setting_obj.router_host}/et/event/sa`, // 上传日志的接口地址
  showLog: true, // 是否在控制台显示日志信息
});

export { sensors,StatisticEventType };
